import React, { useState } from "react";
import { BookOpen, X } from "lucide-react";

// First visit welcome: tells new creators the Beacon Guide exists, where it is and what it covers.
export const GuideWelcome = ({ userId, hasTemplate }) => {
  const key = `ss-guide-welcome-${userId}`;
  const [show, setShow] = useState(() => !localStorage.getItem(key));
  if (!show) return null;
  const dismiss = () => { localStorage.setItem(key, "1"); setShow(false); };
  const open = () => { window.dispatchEvent(new Event("ss-open-guide")); dismiss(); };
  return (
    <div className="relative mb-6 border border-[#14A89A]/40 bg-[#14A89A]/[0.06] p-4 pr-10" data-testid="guide-welcome-card">
      <button onClick={dismiss} aria-label="Dismiss" data-testid="guide-welcome-dismiss" className="absolute top-3 right-3 text-zinc-500 hover:text-white"><X size={16} /></button>
      <div className="flex items-start gap-3">
        <BookOpen size={20} className="text-[#14A89A] shrink-0 mt-0.5" />
        <div>
          <div className="font-body text-sm font-semibold text-white">Welcome to your Beacon. Your Beacon Guide is here whenever you need it.</div>
          <p className="font-body text-xs text-zinc-400 mt-1 leading-relaxed">
            Tap the <span className="text-[#14A89A]">Beacon Guide</span> button at the top of this page anytime. It walks you through building your space, step by step, starting with a guided tour. It covers the basics every Beacon uses, plus its own chapter for the <span className="text-white">Artist</span> and <span className="text-white">Teacher</span> templates. <span className="text-white">Freeform</span> Beacons use the basics.{hasTemplate ? " You can switch templates anytime with Change template below." : " Pick a template just below to get started."}
          </p>
          <div className="flex gap-3 mt-3">
            <button onClick={open} data-testid="guide-welcome-open" className="bg-[#14A89A] text-[#0A0A0A] font-body text-xs font-semibold px-3 py-1.5 hover:brightness-110">Open the Guide</button>
            <button onClick={dismiss} data-testid="guide-welcome-got-it" className="font-body text-xs text-zinc-400 hover:text-white">Got it</button>
          </div>
        </div>
      </div>
    </div>
  );
};
